import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationModel } from 'src/app/models/notification.model';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {
  messages = new Map<string, any>();

  constructor(
    private translateService: TranslateService,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.notificationService.notification$.subscribe((notification: NotificationModel) => {
      this.messages.set(
        notification.text,
        setTimeout(() => {
          this.messages.delete(notification.text);
        }, notification.timeout ?? 99999999)
      );
    });
  }

  displayText(text: string) {
    if (!text) {
      return text;
    }
    return this.translateService.instant(text);
  }

  close(text: string) {
    clearTimeout(this.messages.get(text));
    this.messages.delete(text);
  }
}
